// Redirection commerciale CENTRALISÉE.
// TOUT CTA générique de poursuite / déblocage / renouvellement / passage au cycle suivant
// doit passer OBLIGATOIREMENT par la page de vente (/tarifs) : aucune session Stripe créée
// directement, aucune offre (ex. Essentiel) présélectionnée, aucun prix codé en dur.
// Les paramètres (source, return_to, renewal) servent au SUIVI du parcours et au RETOUR après
// achat — ils ne déterminent JAMAIS automatiquement une formule.
export function offersUrl({ source, returnTo, renewal } = {}) {
  const p = new URLSearchParams();
  if (source) p.set("source", source);
  if (returnTo) p.set("return_to", returnTo);
  if (renewal) p.set("renewal", "1");
  const qs = p.toString();
  return `/tarifs${qs ? `?${qs}` : ""}`;
}

export function goToOffers(navigate, opts = {}) {
  navigate(offersUrl(opts));
}
